import { render } from "./bank-transfer.vue?vue&type=template&id=4cbc962e&scoped=true"
import script from "./bank-transfer.vue?vue&type=script&lang=js"
export * from "./bank-transfer.vue?vue&type=script&lang=js"

import "./bank-transfer.vue?vue&type=style&index=0&id=4cbc962e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbc962e"]])

export default __exports__